import {
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Tab,
  Tabs,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BiVideo } from "react-icons/bi";
import { FaSearch } from "react-icons/fa";
import { useVideoStream } from "../../providers/videoStreams";
import { IVideoStream } from "../../providers/videoStreams/videoStreams.interface";
import { useUser } from "../../providers/users";

import PageHeader from "../pageHeader";
import { Container } from "./styles";
import PaginatedItems from "../Paginate";
import VideoStreamList from "../VideoStreamList";
import VideoUploadModal from "../VideoUploadModal";

const VideoStreamContainer = () => {
  const { roleAdmin } = useUser();
  const { allVideoStreams, getAllVideoStreams } = useVideoStream();
  const { t } = useTranslation();
  const [videoName, setVideoName] = useState("");
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("all");

  //   useEffect(() => {
  //     getAllVideoStreams(activeTab === "active");
  //   }, [activeTab]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
  };

  const handleUploadClick = () => {
    setIsUploadModalOpen(true);
  };

  const filteredVideos: IVideoStream[] = allVideoStreams
    ? allVideoStreams.filter((v: IVideoStream) =>
        v.name.toLowerCase().includes(videoName.toLowerCase())
      )
    : [];

  return (
    <Container>
      <PageHeader
        title={t("video_streams")}
        description={t("video_streams_list")}
        buttonContent={t("upload")}
        buttonPath="video-streams/create"
        verifyRole={true}
        roleToVerify={roleAdmin}
        icon={<BiVideo />}
      />
      <section className="filterSection">
        <TextField
          InputProps={{
            disableUnderline: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton aria-label="search video">
                  {<FaSearch />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          id="standard-search"
          label={t("search_video")}
          type={"text"}
          value={videoName}
          onChange={(e) => setVideoName(e.target.value)}
          variant="filled"
          sx={{
            boxShadow: "rgba(3,3,3,0.1) 2px 2px 4px ",
            textAlign: "center",
            backgroundColor: "#FFF",
            "& fieldset": { border: "none" },
          }}
        />

        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="video filter tabs"
          className="filterTabs"
        >
          <Tab label={t("all_videos")} value="all" />
          <Tab label={t("active_videos")} value="active" />
        </Tabs>
      </section>

      {allVideoStreams && (
        <PaginatedItems
          items={filteredVideos}
          itemsPerPage={5}
          Items={VideoStreamList}
        />
      )}

      <VideoUploadModal
        open={isUploadModalOpen}
        onClose={() => setIsUploadModalOpen(false)}
      />
    </Container>
  );
};

export default VideoStreamContainer;
